import { render, staticRenderFns } from "./InformationList.vue?vue&type=template&id=12ff81e0&"
import script from "./InformationList.vue?vue&type=script&lang=ts&"
export * from "./InformationList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports